<template>
  <footer>
    <div class="footer bg-dark">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-12 col-md-4 text-center text-md-left">
          </div>
          <div class="col-12 col-md-4 text-center">
            <h5 class="no-margin">Hypnobirthing.nl</h5>
            <p>
              een initiatief van<br />
              <a
                href="https://www.puur-zwanger.nl"
                target="_new"
                class="hyperlink-5"
              >PUUR Zwanger</a> en<br />
              <a
                href="https://heybabycoaching.nl/"
                target="_new"
                class="hyperlink-5"
              >Hey Baby Coaching</a>
            </p>

          </div>
          <div class="col-12 col-md-4 text-center text-md-right">
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss">
.undertitle {
  font-size: 14px;
}
</style>